import React from 'react'

import { Formik } from 'formik'
import { Moment } from 'moment'
import * as Yup from 'yup'

import { BenefitDetails } from 'core/application/csiDashboard/csiSearch/getBenefitDetails'

import DatePicker from 'common/components/dataEntry/components/DatePicker'
import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'

import { DefaultSelect } from '../../../../../common/components'
import Checkbox from '../../../../../common/components/dataEntry/components/Checkbox'

interface TriggerEarlyRunoutProps {
  translate: (key: string) => string
  earlyRunoutDate: string
  setEarlyRunoutDate: (runoutDate: string) => void
  showTriggerEarlyRunoutDate: boolean
  setShowTriggerEarlyRunoutDate: (show: boolean) => void
  submitEarlyRunout: () => void
  earlyRunoutDays: number
  setEarlyRunoutDays: (runoutDays: any) => void
  setSendEmail: (sendEmail: any) => void
  loading: boolean
  benefitDetails: BenefitDetails
}

const TriggerEarlyRunout: React.FC<TriggerEarlyRunoutProps> = ({
  translate,
  setEarlyRunoutDate,
  setShowTriggerEarlyRunoutDate,
  showTriggerEarlyRunoutDate,
  earlyRunoutDate,
  submitEarlyRunout,
  earlyRunoutDays,
  setEarlyRunoutDays,
  setSendEmail,
  loading,
  benefitDetails,
}) => {
  const runOutDays = [
    {
      id: 0,
      name: 'End immediately',
    },
    {
      id: 30,
      name: '30 days',
    },
    {
      id: 60,
      name: '60 days',
    },
    {
      id: 90,
      name: '90 days',
    },
  ]

  const onChange = (date: Moment | null, dateString: string) => {
    setEarlyRunoutDate(dateString)
  }

  const onChangeRunOutDaysHandler = (selectedRunOutDays: any) => {
    setEarlyRunoutDays(selectedRunOutDays)
  }

  const onChangeSendEmailHandler = (chkSendEmail: any) => {
    console.log('setting sendEmail')
    console.log(chkSendEmail.target.checked)
    setSendEmail(chkSendEmail.target.checked)
  }

  return (
    <>
      <Modal
        onCancel={() => setShowTriggerEarlyRunoutDate(false)}
        visible={showTriggerEarlyRunoutDate}
        title={translate('csi-dashboard.program-details.trigger-early-runout.title')}
        footer={
          <div>
            <Button
              onClick={() => {
                setShowTriggerEarlyRunoutDate(false)
              }}
            >
              {translate('general.cancel')}
            </Button>
            <Button
              onClick={async () => {
                await submitEarlyRunout()
              }}
              type="primary"
              disabled={earlyRunoutDate === ''}
              loading={loading}
              className="ml-8"
            >
              {translate('general.submit')}
            </Button>
          </div>
        }
      >
        <Formik
          enableReinitialize={true}
          validationSchema={Yup.object({})}
          initialValues={runOutDays}
          onSubmit={(values) => {}}
        >
          <div>
            <div>
              <span className="color-gray-8">
                {translate('csi-dashboard.program-details.trigger-early-runout.paragraph-1')}
              </span>
            </div>
            <div className="mt-16">
              <span className="color-gray-8">
                {translate('csi-dashboard.program-details.trigger-early-runout.paragraph-2')}
              </span>
            </div>

            <div className="mt-16">
              <span className="color-gray-9">
                {translate('csi-dashboard.program-details.trigger-early-runout.final-benefit-date')}
              </span>{' '}
              <br />
              <DatePicker
                onChange={onChange}
                className="width_50"
                disabledDate={(d) => !d || d.isBefore(benefitDetails.startDate, 'day')}
              />
              <br />
              <span className="color-gray-9">
                {translate('csi-dashboard.program-details.trigger-early-runout.early-run-out-days')}
              </span>{' '}
              <br />
              <DefaultSelect
                name="runOutDays"
                defaultValue={[earlyRunoutDays]}
                onChange={onChangeRunOutDaysHandler}
                className="width_50"
                placeholder={'Select run out days'}
                items={runOutDays}
              ></DefaultSelect>
              <Checkbox onChange={onChangeSendEmailHandler} defaultChecked={true} key={'sendemail'}>
                {'Send Email'}
              </Checkbox>
            </div>
          </div>
        </Formik>
      </Modal>
    </>
  )
}

export default TriggerEarlyRunout
